import { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import { Link, useNavigate } from "react-router-dom";
import { getAllProducts } from "../../services/products";
import { getCommoditiesList } from "../../services/commodities";
import SingleProductItem from "./single-item";

export default function Products(params) {
  const [commodities, setCommodities] = useState([]);
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1000 },
      items: params.isFull ? 4 : 3,
    },
    desktop: {
      breakpoint: { max: 1200, min: 990 },
      items: params.isFull ? 3 : 2,
    },
    tablet: {
      breakpoint: { max: 990, min: 600 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  };
  const carouselItems = [
    {
      id: 1,
      title: "شمش طلا 1 گرمی پارسیس 24 عیار با خلوص 999.9",
      silverTitle: "شمش نقره 100 گرمی زیوتو 24 عیار با خلوص 999.9",
      price: 7000000,
      silverPrice: 11000000,
      link: params.landing ? "/sign" : "/trade-market",
      image: "/images/home-carousel-1.jpeg",
      silverImage: "/images/silver-1.png",
    },
    {
      id: 2,
      title: "شمش طلا 5 گرمی پارسیس 24 عیار با خلوص 999.9",
      silverTitle: "شمش نقره 50 گرمی زیوتو 24 عیار با خلوص 999.9",
      price: 27000000,
      silverPrice: 5800000,
      link: params.landing ? "/sign" : "/trade-market",
      image: "/images/home-carousel-2.png",
      silverImage: "/images/silver-2.png",
    },
    {
      id: 3,
      silverTitle: "پلاک نقره 1 اونسی پارسیس 24 عیار با خلوص 999",
      title: "شمش طلا 1 اونسی پارسیس 24 عیار با خلوص 999.9",
      price: 197000000,
      silverPrice: 3500000,
      link: params.landing ? "/sign" : "/trade-market",
      image: "/images/home-carousel-3.jpeg",
      silverImage: "/images/silver-3.jpg",
    },
    {
      id: 4,
      title: "پلاک طلا 20 گرمی پارسیس 24 عیار با خلوص 999.9",
      silverTitle: "شمش نقره 250 گرمی زیوتو 24 عیار با خلوص 999.9",
      price: 127000000,
      silverPrice: 11000000,
      link: params.landing ? "/sign" : "/trade-market",
      image: "/images/home-carousel-4.jpg",
      silverImage: "/images/silver-4.png",
    },
    {
      id: 5,
      title: "پلاک طلا 10 گرمی پارسیس 24 عیار با خلوص 999.9",
      silverTitle: "شمش نقره 500 گرمی زیوتو 24 عیار با خلوص 999.9",
      price: 37000000,
      silverPrice: 58800000,
      link: params.landing ? "/sign" : "/trade-market",
      image: "/images/home-carousel-5.jpg",
      silverImage: "/images/silver-5.png",
    },
    {
      id: 6,
      title: "پلاک طلا 2.5 گرمی پارسیس 24 عیار با خلوص 999.9",
      silverTitle: "شمش نقره 1 کیلویی زیوتو 24 عیار با خلوص 999.9",
      price: 17000000,
      silverPrice: 103500000,
      link: params.landing ? "/sign" : "/trade-market",
      image: "/images/home-carousel-6.jpg",
      silverImage: "/images/silver-6.png",
    },
  ];
  useEffect(() => {
    getCommoditiesList().then((data) => {
      const commodity = data.data.results;
      getAllProducts().then((data) => {
        const resultProducts = data.data.results;
        if (Array.isArray(resultProducts) && resultProducts.length > 0) {
          for (let com of commodity) {
            const product = resultProducts.filter(
              (el) => el.commodity.id == com.id
            );
            com.products = product;
          }
          setCommodities(commodity);
        }
      });
    });
  }, []);
  return (
    <>
      <div className="product-carousel-row">
        {commodities.map(
          (el) =>
            Array.isArray(el.products) &&
            el.products && (
              <div className="carousel-margin-set">
                <Carousel rtl={true} responsive={responsive}>
                  {(el.products || []).map((item) => {
                    return <SingleProductItem params={params} item={item} />;
                  })}
                </Carousel>
              </div>
            )
        )}
      </div>
    </>
  );
}
